import React from "react";

import { Box } from "@material-ui/core";
import { useAppSelector } from "store";

import KPIFact from "components/visuals/KPIFact";
import {
    selectIsLoading,
    selectHasErrors,
    selectClassifiedCompetitorCounts
} from "modules/customer/tools/location/competitionNew/competitionSlice";

const NumberOfCompetitors = () => {
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const competitorCounts = useAppSelector(selectClassifiedCompetitorCounts);
    const selectedStoreNumberOfCompetitors = competitorCounts.competitors ?? 0;

    const label = `Number of competitors within 10 minutes of your selected location`;

    return (
        <Box width="100%" height="100%" data-cy="direct-competitors-within-10-minutes">
            <KPIFact
                loading={isLoading}
                error={hasErrors}
                label={label}
                value={String(selectedStoreNumberOfCompetitors)}
            />
        </Box>
    );
};

export default NumberOfCompetitors;
